import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button } from 'react-bootstrap';
import { LockFill, UnlockFill } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

class TaxRate extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			editable: props.editable,
			taxRate: {
				RATE_ID: '' 
			},
			renderKey: 0
		}
	}	

	componentDidMount() {
		this.loadTaxRate();
	}

	loadTaxRate(event) {
		var self = this;
		
		if (this.props.params.taxRateId) {
			this.ajax({
				type: 'post',
				url: this.getConfig().host + '/Stores/Search',
				data: { 
					__RequestVerificationToken: this.props.user.antiForgeryToken,
					entity: 'TAX_RATE',
					search: { Attribute: 'RATE_ID', Operator: '=', LongValue: this.props.params.taxRateId },
					pageNumber: -1,
					pageSize: -1
				}
			}).done(function (data) {
				if (data.Success) {
					if (data.Data.length > 0) {
						var taxRate = data.Data[0];
						self.mvc2js(taxRate, taxRateColumns);
							
						self.mergeState({
							taxRate: taxRate,
							renderKey: self.state.renderKey + 1
						}, () => {
							if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
						});
					} else {
						self.showAlert('Tax Rate Error', data.Data.length + ' Tax Rates found for ID ' + self.props.params.taxRateId);
					}
				} else {
					self.showAlert('Server Error', data.Message);
				}			
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});	
		} else {
			this.mergeState({
				taxRate: {
					RATE_ID: '(new)',
				},
				renderKey: this.state.renderKey + 1
			});
		}
	}
		
	onChange(accessor, value) {
		var taxRate = this.copyObject(this.state.taxRate);
		this.setByAccessor(taxRate, accessor, value);
		this.mergeState({ taxRate: taxRate, renderKey: this.state.renderKey + 1 });
	}
	
	onDelete(event) {
		var self = this;
		
		this.showOKCancel('Confirm Delete', 'Delete Tax Rate ' + this.props.params.taxRateId + '?', (okClicked) => {
			if (okClicked) {
				// prepare tax rate for deletion
				var taxRate = {
					RATE_ID: self.props.params.taxRateId,
					DELETE_FLAG: 'Y',
					MODIF_BY: self.props.user.name,
					MODIF_DATE: self.dateTimeToMVC(new Date())
				};
				
				this.ajax({
					type: 'POST',
					url: self.getConfig().host + '/Home/Update',
					data: { __RequestVerificationToken: self.props.user.antiForgeryToken, entity: 'STORES.TAX_RATE', data: taxRate }
				}).done(function (data) {
					if (data.Success) {
						self.props.parent.showConfirmation(() => {
							return (<>
								Tax Rate {self.props.params.taxRateId} deleted.
							</>); 
						});
					} else {
						self.showAlert('Server Error', data.Message);
					}			
				}).fail(function (jqXHR, textStatus, errorThrown) {
					self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
				});
			}
		});
	}	
		
	onSubmit(event) {
		var self = this;		
		var url = null;
		
		// make copy of data
		var taxRate = this.copyObject(this.state.taxRate);

		this.js2mvc(taxRate, taxRateColumns);
		
		// if this is a new tax rate
		if (!this.props.params.taxRateId) {
			// set ID to null
			taxRate.RATE_ID = null;
			taxRate.CREATED_BY = this.props.user.name;
			taxRate.CREATE_DATE = this.dateTimeToMVC(new Date());
			url = '/Home/Insert';
		} else {
			taxRate.MODIF_BY = this.props.user.name;
			taxRate.MODIF_DATE = this.dateTimeToMVC(new Date());
			url = '/Home/Update';
		}
		
		this.ajax({
			type: 'POST',
			url: this.getConfig().host + url,
			data: { __RequestVerificationToken: this.props.user.antiForgeryToken, entity: 'STORES.TAX_RATE', data: taxRate }
		}).done(function (data) {
			if (data.Success) {
				var taxRateId = self.props.params.taxRateId || data.ID;
				var verb = self.props.params.taxRateId ? 'updated' : 'inserted';
				self.props.parent.showConfirmation(() => {
					return (<>
						Tax Rate <Link to={'/HeLAD/TaxRates/' + taxRateId}>{taxRateId}</Link> {verb}.
					</>);
				});
			} else {
				self.showAlert('Server Error', data.Message);
			}
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}

	render() {
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						  <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Tax Rate {this.state.taxRate.RATE_ID}&nbsp;&nbsp;
							{this.state.editable ? <UnlockFill style={{ cursor: 'pointer', marginTop: '-4px' }} onClick={() => this.mergeState({ editable: false })} /> : 
							  <LockFill style={{ cursor: 'pointer', marginTop: '-4px' }} onClick={() => this.mergeState({ editable: true })} />}				  
						  </div>
					  </Col>
					</Row>
					<Row>
					  <Col>
						<ChemEdit parent={this} columns={taxRateColumns} data={this.state.taxRate} user={this.props.user} renderKey={this.state.renderKey} 
						   onChange={(accessor, value) => this.onChange(accessor, value)} onSubmit={(event) => this.onSubmit(event)} editable={this.state.editable}>
						  <Form.Group>
							{this.state.editable && <Button id="save" variant="warning" type="submit" className="float-end">Save</Button>}
							{this.state.editable && this.props.params.taxRateId && <Button id="delete" variant="warning" type="button" className="float-end"
							  style={{ marginRight: '20px' }} onClick={(event) => this.onDelete(event)}>Delete</Button>} 
						  </Form.Group>
						</ChemEdit>
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const taxRateColumns = [
	{ Header: 'Tax Rate', accessor: 'TAX_PCT', row: 0, col: 0 },
	{ Header: 'Start Date', accessor: 'START_DATE', type: 'date', row: 0, col: 1 },
	{ Header: 'End Date', accessor: 'END_DATE', type: 'date', row: 0, col: 2 },
	{ Header: 'Default Rate', accessor: 'DEFAULT_FLAG', type: 'checkbox', row: 1, col: 0 },
	{ Header: 'Comments', accessor: 'COMMENTS', type: 'textarea', row: 1, col: 1 }
];

export default withRouter(TaxRate);
